var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"line-clamp",rawName:"v-line-clamp",value:(1),expression:"1"}],staticClass:"color-nobel e2e-product-size text-lowercase",class:_vm.fontSize},[_vm._v(" "+_vm._s(`${_vm.formatUnitSize(_vm.size, _vm.baseSize, _vm.uom)} `)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }